import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { deleteElementFromPath, setValueForPathWithCreate } from '../../object.util'

export const copyCityStringToObject = (pcr: any): IPcr => {
  try {
    if (pcr.patient?.patientDemographics) {
      const ptCity = pcr.patient.patientDemographics.city
      deleteElementFromPath(pcr, 'patient.patientDemographics.city')
      setValueForPathWithCreate(pcr, 'patient.patientDemographics.city.name', ptCity)
      setValueForPathWithCreate(pcr, 'patient.patientDemographics.city.nemsisCode', '')
    }
    if (pcr.patient?.patientDemographics.employer) {
      const ptEmpCity = pcr.patient.patientDemographics.employer.city
      deleteElementFromPath(pcr, 'patient.patientDemographics.employer.city')
      setValueForPathWithCreate(pcr, 'patient.patientDemographics.employer.city.name', ptEmpCity)
      setValueForPathWithCreate(pcr, 'patient.patientDemographics.employer.city.nemsisCode', '')
    }
    if (pcr.patient?.pickupAddress) {
      const refCity = pcr.patient.pickupAddress.city
      deleteElementFromPath(pcr, 'patient.pickupAddress.city')
      setValueForPathWithCreate(pcr, 'patient.pickupAddress.city.name', refCity)
      setValueForPathWithCreate(pcr, 'patient.pickupAddress.city.nemsisCode', '')
    }
    if (pcr.disposition?.destination) {
      const recCity = pcr.disposition.destination.city
      deleteElementFromPath(pcr, 'disposition.destination.city')
      setValueForPathWithCreate(pcr, 'disposition.destination.city.name', recCity)
      setValueForPathWithCreate(pcr, 'disposition.destination.city.nemsisCode', '')
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule copyCityStringToObject ${error}`)
    throw error
  }
}
